Ext.define('SA.view.sidebar.CensusReleaseWindow', {
    alias: 'widget.census-release-window',
    extend: 'SA.view.CenteredModal',

    cls: 'sa-census-release-window',

    initComponent() {
        var {country, selectedRelease} = this;

        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-census-release-window-body',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-census-release-window-preamble',
                        itemId: 'preamble',

                        tpl: [
                            '<strong>Geographic units ({unitExamples}, etc.) can change every census release, and each ',
                            'release is associated with different years of data.</strong><br><br>',
                            '<div class="sa-census-release-window-preamble-geographic-year-prompt">',
                                '<span>Please select the census geographic years that you would like to use.</span>',
                                '<svg class="sa-census-release-window-help-btn x-unselectable"><use href="#sa-icon-question-mark"></use></svg>',
                            '</div>'
                        ],

                        setCountry(country) {
                            var usaUnitExamples = 'counties, cities, census tracts',
                                canUnitExamples = 'census metro areas, census tracts',
                                unitExamples = country === 'USA' ? usaUnitExamples : canUnitExamples;

                            this.update({unitExamples});
                        }
                    }, {
                        xtype: 'release-selector',
                        cls: 'sa-census-release-window-selector',
                        itemId: 'selector'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-census-release-window-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        itemId: 'okBtn',
                        text: 'OK',
                        ui: 'primary',
                        width: 90
                    }, {
                        xtype: 'sa-button',
                        itemId: 'cancelBtn',
                        text: 'Cancel',
                        margin: '0 0 0 12'
                    }
                ]
            }
        ];

        this.callParent();

        this.selector = this.down('#selector');

        this.down('#preamble').setCountry(country);
        this.selector.setCountryAndSelectedRelease({country, selectedRelease});
    },

    getHelpPopup() {
        this.popup = this.popup || Ext.widget({
            xtype: 'historical-mode-help-popup',
            exampleYear: this.country === 'USA' ? 2000 : 2006,
            target: this.el.down('.sa-census-release-window-help-btn')
        });

        return this.popup;
    },

    initEvents() {
        this.callParent();

        this.down('#okBtn').on('click', this.onOkClick, this);
        this.down('#cancelBtn').on('click', this.destroy, this);

        this.el.on('click', this.onHelpBtnClick, this, {delegate: '.sa-census-release-window-help-btn'});
    },

    onHelpBtnClick() {
        var popup = this.getHelpPopup();

        if (!popup.wasRecentlyVisible()) {
            popup.show();
        }
    },

    onOkClick() {
        this.fireEvent('click:ok', this, this.selector.getSelectedRelease());
    }
});